import * as TYPES from './signup-actiontypes';

export const showCancelModal = (isShowCancelModal) => ({
  type: TYPES.SHOW_CANCEL_MODAL,
  isShowCancelModal,
});

export const setVerificationFields = (verificationFields) => ({
  type: TYPES.LOAD_VERIFICATION_FIELDS_SUCCESS,
  verificationFields: verificationFields.split(','),
});

export const setSignUpVerifiedIdentityData = (verifiedIdentityData) => ({
  type: TYPES.SET_SIGN_UP_VERIFIED_IDENTITY_DATA,
  verifiedIdentityData,
});

export const setAuthRepData = (authorizedRepData) => ({
  type: TYPES.SET_AUTHORIZED_REP_DATA,
  authorizedRepData,
});
